import { ROUTE_NAMES } from '~/constants/routes';

export default defineNuxtRouteMiddleware(to => {
    const routeBaseName = useRouteBaseName();
    const localePath = useLocalePath();
    const { isOnboardingInProgress } = useOnboarding();

    if (routeBaseName(to) !== ROUTE_NAMES.SIGNUP_ONBOARDING && isOnboardingInProgress.value) {
        return navigateTo(localePath(ROUTE_NAMES.SIGNUP_ONBOARDING));
    } else if (routeBaseName(to) === ROUTE_NAMES.SIGNUP_ONBOARDING && !isOnboardingInProgress.value) {
        return navigateTo({ name: 'index' });
    }
});
